export const HEADER_HEIGHT = 64;
export const PAGE_HEIGHT = `calc(100dvh - ${HEADER_HEIGHT}px)`;
